import "./ClassesAndCourses.css";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import ClassesAndCoursesViewModel from "./ClassesAndCoursesViewModel";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";

const ClassesAndCourses = () => {
  const [
    ClassesArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AuthUser,
    IsLoading,
  ] = ClassesAndCoursesViewModel();

  // Class Card Dropdown Start
  const [OpenDropdown, setOpenDropdown] = useState(); // undefined is nothing open
  const toggle = (id) => setOpenDropdown(OpenDropdown === id ? undefined : id); // close if currently open
  // Class Card Dropdown End

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper classes-and-courses-page-classes">
        {IsLoading ? (
          <PulseLoader
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "90Vh",
            }}
            color="#3D5EE1"
            size={16}
          />
        ) : (
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Classes</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active">Classes</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            <div className="row classes-row">
              <p className="tooltip-text">Register school first </p>
              {AuthUser?.UserType === "admin" && (
                <Link
                  to="/user/admin/classes/add"
                  className="col-sm-6 col-lg-4 col-xl-3 add-class"
                >
                  <i className="fa-solid fa-plus"></i>
                </Link>
              )}

              {ClassesArray &&
                ClassesArray.map((item, index) => {
                  return (
                    <div
                      className="col-sm-6 col-lg-4 col-xl-3 school-card-container"
                      key={index}
                    >
                      <div className="card invoices-grid-card w-100">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <p className="invoice-grid-link class-session">
                            Session: {item?.Session}
                          </p>
                          <div className="dropdown dropdown-action d-none">
                            <Link
                              onClick={() => toggle(item?.id)}
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="fas fa-ellipsis-v" />
                            </Link>
                            {OpenDropdown === item?.id && (
                              <div
                                style={{
                                  display: OpenDropdown && "block",
                                  position: "absolute",
                                  right: 0,
                                }}
                                className="dropdown dropdown-menu dropdown-menu-end"
                              >
                                <Link
                                  to={`/user/admin/classes/update/${item?.id}`}
                                  className="dropdown-item"
                                >
                                  <i className="far fa-edit me-2" />
                                  Edit
                                </Link>

                                <Link
                                  className="dropdown-item"
                                  to={`/user/admin/classes/details/${item?.id}`}
                                >
                                  <i className="far fa-eye me-2" />
                                  View
                                </Link>

                                {AuthUser?.UserType === "admin" && (
                                  <Link
                                    onClick={() => {
                                      handleOpenDeleteDialog(item?.id);
                                    }}
                                    className="dropdown-item"
                                    href="#"
                                  >
                                    <i className="far fa-trash-alt me-2" />
                                    Delete
                                  </Link>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="card-middle">
                          <span className="card-middle-avatar">
                            {item?.ClassName?.toUpperCase()}
                          </span>
                          <span className="text">
                            Code: {item?.ClassCode.toUpperCase()}
                          </span>
                        </div>
                        <div className="card-body">
                          <div className="card-first-row">
                            {AuthUser?.UserType === "admin" && (
                              <Link
                                to={`/user/admin/classes/update/${item?.id}`}
                                className="dropdown-item"
                              >
                                <i className="far fa-edit link-icon" />
                                Edit
                              </Link>
                            )}

                            {AuthUser?.UserType === "admin" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/admin/classes/details/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                View
                              </Link>
                            ) : AuthUser?.UserType === "student" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/student/classes/details/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                View
                              </Link>
                            ) : AuthUser?.UserType === "teacher" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/teacher/classes/details/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                View
                              </Link>
                            ) : AuthUser?.UserType === "parent" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/parent/classes/details/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                View
                              </Link>
                            ) : (
                              ""
                            )}

                            {AuthUser?.UserType === "admin" && (
                              <Link
                                onClick={() => {
                                  handleOpenDeleteDialog(item?.id);
                                }}
                                className="dropdown-item"
                              >
                                <i className="far fa-trash-alt link-icon" />
                                Delete
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {ClassesArray?.length === 0 && <NoDataFound />}
          </div>
        )}
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this class?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </Fragment>
  );
};

export default ClassesAndCourses;
